<div class="qar-std-desc-container">
  <div class="gt-filter-container">
    <div class="gt-filter-item">
      <i class="fa fa-refresh gt-refresh"
         [class.spinning]="loading"
         role="button"
         tabindex="0"
         title="Refresh Data"
         aria-label="Refresh Data"
         (click)="refresh()"
         (keydown.enter)="refresh()"
         (keydown.space)="$event.preventDefault(); refresh()"></i>
      @if (canCreateQARStdDesc) {
        <div class="btn btn-success btn-xs" role="button" tabindex="0" (click)="addStdDesc()" (keydown.enter)="addStdDesc()">
          Add New Std Desc
        </div>
      }
    </div>
  </div>

  <div adminGrid
       [gridConfig]="gridConfig"
       (gridCallback)="onGridCallback($event)"
       (gridDataLoaded)="onGridDataLoaded($event)"
       (loadingStateChange)="loading = $event"
       class="gizmo-grid qar-std-desc-grid"
       tabindex="2"></div>
</div>
